import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxButtonModule } from '../button/button.module';
import { IconSvgComponent } from '../icon/icon.component';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { InputLoadingModule } from '../input-loading/input-loading.module';

@Component({
  selector: 'rx-applications-export-button',
  standalone: true,
  templateUrl: './export-button.component.html',
  styleUrls: ['./export-button.component.scss'],
  imports: [CommonModule, RxButtonModule, IconSvgComponent, LoadingSpinnerComponent, InputLoadingModule],
})
export class ExportButtonComponent {
  @Input() isLoading = false;
  @Input() exportLabel = 'Export';
  @Input() downloadingLabel = 'Downloading';
  @Input() testIdPrefix = 'test-export';
  @Input() disabled = false;
  @Output() buttonClick: EventEmitter<void> = new EventEmitter<void>();

  onExport(): void {
    if (!this.isLoading && !this.disabled) {
      this.buttonClick.emit();
    }
  }

  get label(): string {
    return this.isLoading ? this.downloadingLabel : this.exportLabel;
  }

  get testId(): string {
    if (this.isLoading) {
      return `${this.testIdPrefix}-button-downloading`;
    }
    if (this.disabled) {
      return `${this.testIdPrefix}-button-disabled`;
    }
    return `${this.testIdPrefix}-button`;
  }
}
